import React, { useState } from "react";
import { userService } from "../../../_services";
import { Switch } from "@/components/ui/switch";
import { Loader2 } from "lucide-react";

/**
 * Link Toggle Component
 * Modernized with shadcn Switch - Toggle active/inactive state for secondary links
 */
function LinkToggle({ objectuid, linksuffix, isactive, deactivated }) {
    const [isActive, setIsActive] = useState(isactive);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleToggle = async (checked) => {
        setLoading(true);
        setError('');
        
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const [userid, username] = Usermeta_Data.split(':');
            
            // Call EditSecondLink API with correct parameters
            const apidata = await userService.EditSecondLink(
                userid,
                username,
                objectuid,
                linksuffix,
                0, // Flag
                checked // IsActive
            );
            
            if (apidata && apidata.length > 0) {
                setIsActive(checked);
                if (deactivated) deactivated();
            }
        } catch (err) {
            console.error('Error toggling link:', err);
            setError('Failed to update status');
            // Revert the switch state on error
            setIsActive(!checked);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center gap-2">
            {loading ? (
                <Loader2 className="h-4 w-4 animate-spin text-accent" />
            ) : (
                <Switch
                    checked={isActive}
                    onCheckedChange={handleToggle}
                    disabled={loading}
                />
            )}
            {error && (
                <span className="text-xs text-destructive">{error}</span>
            )}
        </div>
    );
}

export default LinkToggle;

